import React, { createContext, useState, useEffect } from "react"

import { useAppSelector } from "redux/hooks"
import { selectAccessToken } from "redux/features/auth/authSlice"
import TokenService from "redux/api/tokenService"

interface AuthContext {
  accessToken: string | null | undefined
  signedIn: boolean
}

export const AuthContext = createContext<AuthContext>({
  accessToken: null,
  signedIn: false,
})

export const AuthContextProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const accessToken = useAppSelector((state) => selectAccessToken(state))
  const [signedIn, setSignedIn] = useState(false)

  const checkAccessToken = () => {
    if (accessToken) {
      setSignedIn(TokenService.validate(accessToken))
    } else {
      setSignedIn(false)
    }
  }

  useEffect(() => checkAccessToken(), [])

  return (
    <AuthContext.Provider value={{ accessToken, signedIn }}>
      {children}
    </AuthContext.Provider>
  )
}
